import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "apple-price-comparison" }
const _hoisted_2 = { class: "apple-price-comparison__loading-inner" }

import { computed, ref } from 'vue'
import { Browser } from '@capacitor/browser'

import { AppStoreBillingView, PlanView } from '@/models/billing'
import { assertNotNull } from '@/helpers/typing'
import { auth } from '@/services/auth'
import { emitter } from '@/services/mitt'

import CircleSpinner from '@/components/ui/CircleSpinner.vue'
import BottomSheet from '@/app/components/BottomSheet.vue'
import BillingApplePriceCard16218 from './BillingApplePriceCard16218.vue'
import { platform } from '@/services/platform'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingApplePriceComparison16218',
  props: {
    billing: {},
    plan: {}
  },
  emits: ['appStoreSubscribe'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const bottomSheet = ref<InstanceType<typeof BottomSheet> | null>(null)

const isSubscribing = ref(false)

const stripePlan = computed(() => {
  const plan =
    props.plan.id === 'plan_annual'
      ? props.billing.stripeAnnualPlan16218
      : props.billing.stripeMonthlyPlan16218

  return assertNotNull(plan)
})

function appStoreSubscribe(): void {
  isSubscribing.value = true
  Mixpanel.trackAppStoreButton(props.plan)
  emit('appStoreSubscribe')
}

/**
 * The iOS external payment flow.
 *
 * Open the Stripe subscription popup in a new in-app browser window (we can't
 * open it directly in the app due to the App Store's rules).
 * https://github.com/shortformhq/main/issues/16218
 */
async function openExternalPaymentPage(): Promise<void> {
  isSubscribing.value = true
  Mixpanel.trackExternalPaymentButton(props.plan)

  const baseUrl = window.location.origin
  const paymentPageUrl = new URL(`${baseUrl}/app/billing-apple-external`)
  const authToken = assertNotNull(auth.getToken())
  const deviceInfo = await platform.deviceInfo()

  // The page in the in-app browser is a different container,
  // so the user will not be logged in. We pass the auth token
  // in the URL query so that the user doesn't have to manually
  // log in again.
  paymentPageUrl.searchParams.set('authToken16218', authToken)
  // The selected plan's ID.
  paymentPageUrl.searchParams.set('plan16218', props.plan.id)
  // The app version (for mocking the device info we send to the backend in
  // the `savePaymentMethod` request).
  paymentPageUrl.searchParams.set('appVersion16218', deviceInfo.appVersion)

  Browser.open({ url: paymentPageUrl.toString(), presentationStyle: 'popover' })

  // When the in-app browser is closed automatically after subscribing.
  emitter.on('closeInAppBrowser16218', updateBilling)
  // When the in-app browser is closed manually by the user.
  Browser.addListener('browserFinished', updateBilling)
}

async function updateBilling(): Promise<void> {
  emitter.off('closeInAppBrowser16218', updateBilling)
  Browser.removeAllListeners()

  await props.billing.updateAfterExternalPage16218(props.plan, close)
  isSubscribing.value = false
}

function show(): void {
  isSubscribing.value = false
  bottomSheet.value?.view.open()
}

function close(): void {
  bottomSheet.value?.view.close()
}

__expose({
  show,
  close,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    ref_key: "bottomSheet",
    ref: bottomSheet,
    fullscreen: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "apple-price-comparison__title" }, "Choose a payment method", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "apple-price-comparison__subtitle" }, " All payment methods are 100% secure. ", -1)),
        _createVNode(BillingApplePriceCard16218, {
          class: "apple-price-comparison__card",
          plan: __props.plan,
          isExternal: false,
          onSubscribe: appStoreSubscribe
        }, null, 8, ["plan"]),
        _createVNode(BillingApplePriceCard16218, {
          class: "apple-price-comparison__card",
          plan: stripePlan.value,
          isExternal: true,
          onSubscribe: openExternalPaymentPage
        }, null, 8, ["plan"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (isSubscribing.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "apple-price-comparison__loading-screen",
                  onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(CircleSpinner, { size: 24 }),
                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "apple-price-comparison__loading-text" }, "Loading...", -1))
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512))
}
}

})